export default "__VITE_ASSET__rVe2Rc3y__"